import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { COOKIE_SESSION_TOKEN } from './session-token';

interface AdminAuthState {
  token: string | null;
  user: { id: string; email: string; role: string } | null;
  setAuth: (token: string | null | undefined, user: AdminAuthState['user']) => void;
  logout: () => void;
}

const ADMIN_AUTH_STORAGE_KEY = 'trade-bridge-admin-auth-session';

function migrateAdminSessionStorage(): void {
  if (typeof window === 'undefined') return;
  const existing = localStorage.getItem(ADMIN_AUTH_STORAGE_KEY);
  const legacy = sessionStorage.getItem(ADMIN_AUTH_STORAGE_KEY);
  if (!existing && legacy) {
    localStorage.setItem(ADMIN_AUTH_STORAGE_KEY, legacy);
  }
  sessionStorage.removeItem(ADMIN_AUTH_STORAGE_KEY);
}

if (typeof window !== 'undefined') {
  migrateAdminSessionStorage();
}

export const useAdminAuthStore = create<AdminAuthState>()(
  persist(
    set => ({
      token: null,
      user: null,
      setAuth: (token, user) => {
        if (typeof window !== 'undefined') {
          localStorage.removeItem('access_token');
        }
        set({ token: token || COOKIE_SESSION_TOKEN, user });
      },
      logout: () => {
        if (typeof window !== 'undefined') {
          localStorage.removeItem('access_token');
          sessionStorage.removeItem(ADMIN_AUTH_STORAGE_KEY);
        }
        set({ token: null, user: null });
      },
    }),
    {
      name: ADMIN_AUTH_STORAGE_KEY,
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
